import { useEffect } from 'react';
import { ArrowIcon, MarketingFooter, MarketingHeader } from '../components/MarketingChrome';
import { pluginLaunch } from '../data/pluginLaunch';
import { appPath } from '../lib/config';
import './chatgpt-plugin.css';

export function ChatGptPluginPage() {
  useEffect(() => {
    document.title = 'Paddiq for ChatGPT | Coming soon';
  }, []);

  return (
    <div className="marketing-home">
      <a className="mh-skip" href="#main">
        Skip to content
      </a>
      <MarketingHeader />
      <main id="main">
        <section className="plugin-hero">
          <div className="mh-shell plugin-hero__grid">
            <div className="plugin-hero__copy">
              <p className="mh-kicker">Paddiq for ChatGPT</p>
              <h1>Ask ChatGPT about your race sessions.</h1>
              <p className="plugin-hero__lead">
                Find a session, compare laps, and look back at your kart setup in a conversation.
                Our upcoming plugin will connect ChatGPT to the race data already in your Paddiq
                account.
              </p>
              <div className="mh-actions">
                <a className="mh-button" href="#what-to-ask">
                  See what you can ask <ArrowIcon />
                </a>
                <a className="mh-text-link mh-text-link--purple" href={appPath('/login')}>
                  Open Paddiq <ArrowIcon />
                </a>
              </div>
              <p className="plugin-hero__note">Coming soon for drivers, coaches, and teams.</p>
            </div>
            <div className="plugin-hero__visual">
              <img
                src="/illustration-team-debrief.png"
                alt="Illustration of a racing team discussing session data during a debrief"
                width="1536"
                height="1024"
              />
              <aside className="plugin-launch" aria-labelledby="plugin-launch-title">
                <p className="plugin-launch__status" id="plugin-launch-title">
                  <span aria-hidden="true" /> {pluginLaunch.status}
                </p>
                <p>{pluginLaunch.timing}</p>
                <p className="plugin-launch__availability">
                  The plugin is not yet available to install.
                </p>
                <p className="plugin-updated">
                  Update: <time dateTime={pluginLaunch.updatedAt}>{pluginLaunch.updatedLabel}</time>
                </p>
              </aside>
            </div>
          </div>
        </section>
        <section className="mh-section plugin-questions" id="what-to-ask">
          <div className="mh-shell">
            <p className="mh-kicker">Questions to try after release</p>
            <h2>Start with the run you want to understand.</h2>
            <div className="mh-three-columns">
              <article>
                <span className="mh-index">01 / COMPARE</span>
                <h3>Find and compare your laps.</h3>
                <p>
                  Find recorded sessions and compare eligible laps across multiple sessions on the
                  same circuit.
                </p>
                <blockquote>
                  “Compare my fastest laps across recent sessions on the same circuit.”
                </blockquote>
              </article>
              <article>
                <span className="mh-index">02 / ANALYZE</span>
                <h3>Take a closer look at the data.</h3>
                <p>
                  Explore available telemetry channels and saved trace views to help understand
                  where time was gained or lost.
                </p>
                <blockquote>“Show the speed trace for my fastest lap.”</blockquote>
              </article>
              <article>
                <span className="mh-index">03 / REVIEW</span>
                <h3>Look back at your setup.</h3>
                <p>
                  Review kart setup history alongside your sessions to see what changed between
                  runs.
                </p>
                <blockquote>“What changed in my kart setup between these sessions?”</blockquote>
              </article>
            </div>
            <p className="plugin-questions__note">
              Answers depend on the data recorded in Paddiq. Available channels vary by session;
              charts depend on support in the chat client.
            </p>
          </div>
        </section>
        <section className="mh-story plugin-access">
          <div className="mh-shell mh-story__inner">
            <div>
              <p className="mh-kicker">Connected to your account</p>
              <h2>Your Paddiq access still applies.</h2>
            </div>
            <div>
              <p>
                You’ll sign in to Paddiq when connecting the plugin and review the permissions it
                requests. The connection can only access data your Paddiq account is allowed to use.
              </p>
              <p>
                Supported edits depend on the permissions you grant. Deletions and other sensitive
                changes require you to approve the exact proposed change in Paddiq before it runs.
              </p>
              <p>
                While the plugin is in review, you can keep uploading and reviewing sessions in
                Paddiq as usual.
              </p>
              <a className="mh-text-link mh-text-link--purple" href="/support">
                Ask us about the plugin <ArrowIcon />
              </a>
            </div>
          </div>
        </section>
      </main>
      <MarketingFooter />
    </div>
  );
}
